<template>
  <div class="activate">
    <div class="activate__container">
      <div class="activate__brand">
        <img class="tingg-brand-logo" src="https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png" height="64" alt="Tingg"/>
      </div>

      <div class="activate__card">
        <!-- Account activated message -->
        <div class="row">
          <div class="align-items-center col-12 d-flex justify-content-center">
            <i v-if="status === 'pending'" id="activation-pending-icon" class="material-icons">sync</i>
            <i v-if="status === 'success'" id="activation-succeded-icon" class="material-icons">thumb_up_alt</i>
            <i v-if="status === 'failed'" id="activation-failed-icon" class="material-icons">thumb_down_alt</i>
            <br>
          </div>
        </div>

        <h4 class="activate__card-title text-uppercase" v-if="status === 'pending'">Activating your account</h4>
        <h4 class="activate__card-title text-uppercase" v-if="status === 'success'">Account activated</h4>
        <h4 class="activate__card-title text-uppercase" v-if="status === 'failed'">Account activation failed</h4>

        <div class="row">
          <div class="col-12">
            <p class="text-center text-muted" v-if="status === 'pending'">
              Your account is currently being verified, this will take a few seconds.
            </p>
            <p class="text-center text-muted" v-if="status === 'failed'">
              Your account could not be verified. Check whether the link was copied correctly.
            </p>
            <p class="text-center text-muted" v-if="status === 'success'">
              Your account has been successfully activated. Login to start integrating your application to Mula.
            </p>
          </div>
        </div>
        <!-- End of the account activated message -->

        <form id="activation-page-login-button" v-on:submit.prevent="$router.push('/home')" novalidate v-if="status === 'success'">
          <button class="mula-btn mula-btn--primary" type="submit">
            Login
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  /***
   * Activate view
   *
   * Possible statuses: ['pending', 'failed', 'successful']
   */
  import _ from 'lodash'
  import { mapActions } from 'vuex'
  import Auth from '@/api/services/auth.js'

  const logInfo = !!(process.env.NODE_ENV !== 'production')

  export default {
    data () {
      return {
        status: 'pending'
      }
    },
    methods: {
      ...mapActions('auth', ['login']),
      ...mapActions('services', ['saveServices']),
      ...mapActions('user', ['saveUserInformation', 'saveUserKeys']),
      verifyAccount () {
        // Set the page to a pending state waiting for the response from the checkout engine
        this.status = 'pending'

        Auth.attemptToVerifyAccount({ token: this.$route.params.token })
          .then(response => {
            logInfo && console.log('User was successfully verified', response)
            // Set the status to a success status
            this.status = 'success'
            // Persist the user's token
            this.login(response.DATA.authorizationToken)

            // Persist the user's information, services and keys
            this.saveServices(_.pick(response.DATA, ['serviceDetails']))
            this.saveUserKeys(_.pick(response.DATA, ['clientAccessKeys', 'oauthKeyDetails']))
            this.saveUserInformation(_.omit(response.DATA, [
              'authorizationToken',
              'clientAccessKeys',
              'oauthKeyDetails',
              'serviceDetails'
            ]))
          })
          .catch(response => {
            logInfo && console.log('User was not verified', response)
            // Set the status to a failed status
            this.status = 'failed'
          })
      }
    },
    mounted () {
      this.verifyAccount()
    },
    name: 'Activate'
  }
</script>

<style lang="scss">
  @import "../styles/theme";

  .activate {
    background-image: linear-gradient(to bottom right, $tingg-primary-red, $tingg-purple);

    width: 100%;
    height: 100vh;

    display: flex;
    align-items: start;
    justify-content: center;
  }

  [id^="activation"][id$="icon"] {
    font-size: 96px;
  }

  #activation-failed-icon {
    color: $tingg-primary-red;
  }
  
  #activation-succeded-icon {
    color: $tingg-green;
  }

  .activate__container {
    @include make-col-ready();

    @include media-breakpoint-down(xl) {
      @include make-col(4);
    }

    @include media-breakpoint-down(md) {
      @include make-col(8);
    }

    @include media-breakpoint-down(sm) {
      @include make-col(10);
    }

    @include media-breakpoint-down(xs) {
      @include make-col(12);
    }

    height: 75%;

    margin-top: 2.5rem;
  }

  .activate__card {
    width: 100%;
    border-radius: 2px;
    padding: 1.5rem 3rem;
    background-color: $background-white;
  }

  .activate__card-title {
    width: 100%;

    font-size: 25px;
    text-align: center;

    margin-bottom: 1rem;
  }

  .activate__brand {
    width: 100%;

    display: flex;
    align-items: center;
    margin-bottom: 2.5rem;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/Activate.vue